<template>
  <div>
    <a class="aiBox" href="https://robot.chaoxing.com/chatDigitalHuman?unitId=183837&robotId=010d882e1dda429dbab8988f4f9bcbe7" style="display:none;position: fixed;right:0.3rem;bottom:2rem;z-index: 9999; ">
      <img :src="aiImg" style="width: 1.5rem;" alt="">
    </a>
    <div style="height: 40px;line-height: 40px;text-align: center;font-size: 18px;">{{ titlename }}</div>
    <div class="search-wrapper" @click="to('/search')">
      <div class="search">
        <img src="./search.png">搜索课程
      </div>
    </div>
    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <!--<div class="swiper-slide">
            <div class="banner-item f-img-box">
              <img src="./banner.jpg">
            </div>
          </div>-->
          <div class="swiper-slide" v-for="item in banners">
            <div class="banner-item f-img-box">
              <a :href="item.url" style="overflow: hidden;transform: translate3d(0,0,0);">
                <img :src="item.cover_img" style="transform: translate3d(0,0,0);">
              </a>
            </div>
          </div>
        </div>
        <div class="banner-dots">

        </div>
      </div>
    </div>
    <div class="nav">
      <ul class="nav-items f-cb">
        <li class="nav-item nav-item-all" @click="to('/category')">全部分类</li>
        <li class="nav-item nav-item-o" @click="to('/circle/hot')">交流圈</li>
        <li class="nav-item nav-item-lesson" @click="to('/me-lesson')">课程表</li>
        <li class="nav-item nav-item-me" @click="to('/me')">我的慕课</li>
      </ul>
    </div>
    <div class="group" v-if="meLesson.length > 0">
      <div class="group-title f-cb">
        <div class="group-title-text">课程表</div>
        <div class="group-title-all" @click="to('/me-lesson')">查看全部 ></div>
      </div>
      <div class="lesson">
        <ul class="lesson-items">
          <!--<li class="lesson-item lesson-item-unopen">
                        <div class="lesson-main f-cb">
                            <div class="lesson-pic f-img-box">
                                <img src="./lesson-pic.png">
                                <div class="lesson-status-open">正在开课</div>
                                <div class="lesson-status-unopen">即将开课</div>
                            </div>
                            <div class="lesson-content">
                                <div class="lesson-title o1">葡萄酒与西方文化葡萄酒与西方文化</div>
                                <div class="lesson-place o1">天津文化馆</div>
                                <div class="lesson-date o1">2018.8.1-2018.9.15</div>
                            </div>
                        </div>
                    </li>-->
          <li class="lesson-item lesson-item-open" v-for="item in meLesson"
              @click="$router.push('/lesson-detail/'+item.id)">
            <div class="lesson-main f-cb">
              <div class="lesson-pic f-img-box">
                <img :src="item.cover_img">
                <div class="lesson-status-open" v-if="getLessonStatus(item)===1">正在开课</div>
                <div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===2">即将开课</div>
                <div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===3">已过期</div>
                <div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===4">暂未开放</div>
              </div>
              <div class="lesson-content">
                <div class="lesson-title o1">{{ item.course_title }}</div>
                <div class="lesson-place o1">{{ item.teacherNickName }}</div>
                <div class="lesson-date o1">{{ getTerm(item) }}</div>
              </div>
            </div>
            <div class="lesson-rate" v-if="getLessonStatus(item)===1">
              <div class="lesson-rate-line"></div>
              <div class="lesson-rate-line2" :style="{width:item.schedule}"></div>
              <div class="lesson-rate-block-wrapper">
                <div class="lesson-rate-block" :style="{left:item.schedule}">
                  {{ conversionStudyPercent(item.schedule) }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="group" v-if="vkey!='g1tVY'">
      <div class="group-title f-cb">
        <div class="group-title-text">名师风采</div>
      </div>
      <div class="teacher">
        <div class="teacher-main">
          <ul class="teacher-items f-cb">
            <!--<li class="teacher-item">
                            <div class="teacher-item-pic f-img-box">
                                <img src="./teacher.png">
                            </div>
                            <div class="teacher-item-content">
                                <div class="teacher-name o1">杨振宁</div>
                                <div class="teacher-line1 o1">清华大学</div>
                                <div class="teacher-line2 o1">院士</div>
                            </div>
                        </li>-->
            <li class="teacher-item" v-for="item in teachers" @click="to('/teacher-lesson/'+item.id)">
              <div class="teacher-item-bg" :style="{'background-image':'url('+item.avatar+')'}"></div>
              <div class="teacher-item-inner">
                <div class="teacher-item-pic f-img-box">
                  <img :src="item.avatar?item.avatar:'./static/img/default-teacher.png'">
                </div>
                <div class="teacher-item-content">
                  <div class="teacher-name o1">{{ item.nick_name }}</div>
                  <div class="teacher-line1 o1">{{ item.company }}</div>
                  <div class="teacher-line2 o1">{{ item.teacher_title }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <listtemplate v-for="(item,index) in templatedata" :tem_data="item" :cindex="index"></listtemplate>
    <!--<div class="group">-->
    <!--<div class="group-title f-cb">-->
    <!--<div class="group-title-text">{{latestLessonTitle}}</div>-->
    <!--<div class="group-title-all" @click="to('/lesson-list/4/0')">更多课程 ></div>-->
    <!--</div>-->
    <!--<div class="lesson2">-->
    <!--<ul class="lesson2-items">-->
    <!--<li class="lesson2-item" v-for="item in latestLesson" @click="toLessonDetail(item.id)">-->
    <!--<div class="lesson2-main">-->
    <!--<div class="lesson2-pic f-img-box">-->
    <!--<img :src="item.cover_img">-->
    <!--</div>-->
    <!--<div class="lesson2-content">-->
    <!--<div class="lesson2-name o1">{{item.teacher}}</div>-->
    <!--<div class="lesson2-num o1">{{countLessonNum(item.stu_num)}}人</div>-->
    <!--</div>-->
    <!--<div class="lesson2-score">{{item.score!=0?item.score:"暂无评"}}分</div>-->
    <!--</div>-->
    <!--<div class="lesson2-text o1">{{item.title}}</div>-->
    <!--</li>-->
    <!--<li class="lesson2-item lesson2-item-empty"></li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="group">-->
    <!--<div class="group-title f-cb">-->
    <!--<div class="group-title-text">{{topicData.title}}</div>-->
    <!--<div class="group-title-all" @click="to('/lesson-list/2/0')">更多课程 ></div>-->
    <!--</div>-->
    <!--<div class="collection">-->
    <!--<ul class="collection-items">-->
    <!--<li class="collection-item f-cb" v-for="item in topicData.list" @click="$router.push('/topic/'+item.id)">-->
    <!--<div class="collection-left">-->
    <!--<div class="collection-pic f-img-box">-->
    <!--<img :src="item.cover_img">-->
    <!--</div>-->
    <!--<div class="collection-left-text">合集</div>-->
    <!--</div>-->
    <!--<div class="collection-content">-->
    <!--<div class="collection-title o1">{{item.title}}</div>-->
    <!--<div class="collection-text o1">{{item.center_name}}</div>-->
    <!--<div class="collection-info f-cb">-->
    <!--<div class="collection-num">{{item.course_num}}门课</div>-->
    <!--<div class="collection-hot">{{item.stu_num}}人在学</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <div class="all-lesson" @click="to('/lesson-list/1/0')">查看全部课程>></div>
  </div>
</template>
<script>
import tools from '../../util/tools.js'
import listtemplate from '../list-template/list-template.vue'
import $ from "jquery";
import aiImg from "../../../static/img/ai.png"

export default {
  name: "index",
  components: {listtemplate},
  data() {
    return {
      classicLesson: [],
      latestLesson: [],
      latestLessonTitle: "",
      classicLessonTitle: "",
      topicData: {},
      teachers: [],
      banners: [],
      meLesson: [],
      templatedata: [],//模板数据
      titlename: "",
      vkey:'',
      aiImg:aiImg
    }
  },
  created() {
    //获取导航参数
    function geturl_j2(name){
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
    var v_key = geturl_j2('v_key');
    if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent)) {
      window.location.href = "/mooc_free_login?v_key=" + v_key;
    }
    this.vkey = v_key
    //返回重定向
    if (this.$store.state.isLogin == 1 && this.$route.params.openid) {
      this.$router.push("/");
    }
    //是否需要授权登录
    if (this.$route.params.openid) {
      this.$api.get("", {
        api: '/wechat/server/get_user_info',
        openid: this.$route.params.openid
      }, res => {
        if (res.status == 1) {
          this.$store.commit("setLogin");
          this.$store.commit("setfirstlink");
          this.$router.push("/");
          // window.location.href = '/mooc-wx';
        } else {
          console.log('shibai');
        }
      })
    }
    this.$api.get("", {
      api: '/v1/mooc_center/get_trial_status',
      type: 2
    }, res => {
      this.titlename = res.data.center_name;
      console.log(this.titlename);
      console.log(res.data.center_name);
    })
    //banner
    this.$api.get("", {
      api: "/v1/banner/getBanners",
      type: 2
    }, res => {
      if (res.code == 12222 && this.tools.getStorage("mooc_user_id")) {
        this.$store.commit("setLogin");
      }
      this.banners = res.data;
      //开启轮播图
      this.$nextTick(function () {
        var bannerSwiper = new Swiper('.banner .swiper-container', {
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          speed: 500,
          pagination: {
            el: '.banner-dots',
            bulletClass: "banner-dot",
            bulletActiveClass: "banner-dot-active"
          }
        });
      })
    })
//      	//最新课程
//			this.$api.get("",{
//				api:"/v1/column/column_index",
//				type:1,
//				len:4
//			},res => {
//				this.lastestLesson=res.data.mooc;
//			})
//			//经典课程
//			this.$api.get("",{
//				api:"/v1/column/column_index",
//				type:2,
//				len:4
//			},res => {
//				this.classicLesson=res.data.mooc;
//			})
//			//专题列表
//			this.$api.get("",{
//				api:"/v1/special_subject/index",
//			},res=>{
//				this.topicData=res.data;
//			})

    //最新课程、经典课程和专题列表从新接口取
    //template_id 经典 3 最新 1 专题 2
    this.$api.get("", {
      api: "/v1/home_page/getcategory",
      type: 2
    }, res => {
      var data = res.data;
      this.templatedata = data;
    })
    this.$api.get("", {
      api: "/v1/home_page/getCss",
      type: 2
    }, res => {
      var data = res.data;
      document.getElementById('liststyle').innerHTML = data;
    })
    //名师风采
    this.$api.get("", {
      api: "/v1/user/index1",
      /*type:2,
      status:1,*/
      len: 10,
      page: 1
    }, res => {
      this.teachers = res.data.list;
      //设置名师列表宽度
      this.$nextTick(function () {
        document.querySelector(".teacher-items").style.width = document.querySelectorAll(".teacher-item").length * 4.213 + "rem";
      })
    })
    //课程表
    if (this.$store.state.isLogin) {
        this.$api.get("",
          {
            api: "/v1/my/myCourse",
            user_type: this.tools.getStorage("user_type"),
            len: 2,
            page: 1
          },
          res => {
            this.meLesson = res.data;
          },
          null,
          false)

    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.vkey=='RVtzS'){
        $('.aiBox').show()
      }
    })
  },
  methods: {
    countLessonNum(num) {
      if (num >= 1000) {
        num = parstInt(num / 1000);
      }
      return num;
    },
    to(name) {
      this.$router.push(name);
    },
    toLessonDetail(id) {
      this.$router.push("lesson-detail/" + id);
    },
    getLessonStatus(item) {
      //返回1正在开课 2即将开课 3已过期 4暂未开放
      var openStatus = item.open_status,
        num,
        now = new Date().getTime() / 1000,
        stime = item.start_time,
        etime = item.end_time;
      if (openStatus == 2) {
        num = 1;
      } else if (openStatus == 0) {
        num = 4;
      } else if (openStatus == 1) {
        if (now < stime) {
          num = 2;
        } else if (now > etime) {
          num = 3;
        } else {
          num = 1
        }
      }
      return num;
    },
    conversionStudyPercent(str) {
      var percent = parseInt(str);
      if (percent == 0) {
        return "未开始";
      } else if (percent == 100) {
        return "已学完";
      } else {
        return "已学 " + str;
      }
    },
    getTerm(item) {
      var statusText = "";
      if (item.open_status === 0) {
        statusText = "暂未开放";
      } else if (item.open_status === 2) {
        statusText = "无限期";
      } else {
        statusText = this.tools.timestampConversion(item.start_time) + "-" + this.tools.timestampConversion(item.end_time);
      }
      return statusText;
    }
  },
}
</script>

<style>
.search-wrapper {
  z-index: 40;
  position: absolute;
  top: 40px;
  left: 0;
  height: 1.173rem;
  width: 10rem;
  background: url(./search-bg.png) center center no-repeat;
  background-size: 100%;
}

.search {
  z-index: 50;
  position: absolute;
  top: 0.186rem;
  left: 0.4rem;
  width: 9.2rem;
  height: 0.8rem;
  background: rgba(255, 255, 255, 0.6);
  font-size: 0.453rem;
  line-height: 0.8rem;
  text-align: center;
  border-radius: 0.4rem;
  color: #fff;
}

.search img {
  width: 0.48rem;
  margin-right: 0.266rem;
  vertical-align: middle;
}

.banner {
  height: 4.64rem;
}

.banner .swiper-slide {
  height: 4.64rem;
}

.banner-item {
  height: 100%;
}

.banner-dots {
  z-index: 10;
  position: absolute;
  bottom: 0.16rem;
  text-align: center;
}

.banner-dot {
  display: inline-block;
  width: 0.053rem;
  height: 0.053rem;
  margin: 0 0.067rem;
  background: #fff;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  transition: width .5s;
}

.banner-dot-active {
  width: 0.453rem;
}

.nav {
  padding-top: 0.707rem;
  margin-bottom: 0.827rem;
}

.nav-item {
  float: left;
  width: 25%;
  padding-top: 1.253rem;
  background: top center no-repeat;
  background-size: 1.013rem;
  font-size: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  color: #333;
}

.nav-item-all {
  background-image: url(./nav-all1.png)
}

.nav-item-o {
  background-image: url(./nav-o1.png)
}

.nav-item-lesson {
  background-image: url(./nav-lesson1.png)
}

.nav-item-me {
  background-image: url(./nav-me1.png)
}

.group {
  margin-top: 0.533rem;
  border-bottom: 1px solid #eee;
}

.group-title {
  /*height:0.64rem;*/
}

.group-title-text {
  float: left;
  padding-left: 0.973rem;
  font-size: 0.64rem;
  line-height: 0.64rem;
  background: url(./title-bg.png) 0.4rem 0.173rem no-repeat;
  background-size: 0.427rem;
  font-weight: bold;
  color: #333;
}

.group-title-all {
  float: right;
  margin-top: 0.133rem;
  margin-right: 0.4rem;
  font-size: 0.453rem;
  letter-spacing: 1px;
  color: #999;
}

.lesson {
  padding-bottom: 0.266rem;
}

.lesson-items {
  padding-top: 0.706rem;
}

.lesson-item {
  margin: 0 0.4rem 0.4rem 0.4rem;
}

.lesson-pic {
  position: relative;
  float: left;
  width: 3.733rem;
  height: 2.133rem;
  border-radius: 0.106rem;
}

.lesson-status-open,
.lesson-status-unopen {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.64rem;
  height: 0.613rem;
  border-radius: 0.106rem;
  font-size: 0.346rem;
  color: #fff;
  line-height: 0.613rem;
  text-align: center;
}

.lesson-status-open {
  background: #ec6d3a;
}

.lesson-status-unopen {
  background: #3192e0;
}

.lesson-item-open .lesson-status-open {
  display: block;
}

.lesson-item-unopen .lesson-status-unopen {
  display: block;
}

.lesson-content {
  float: right;
  width: 5.2rem;
  padding-top: 0.133rem;
}

.lesson-title {
  font-size: 0.453rem;
  color: #333;
}

.lesson-place {
  margin-top: 0.213rem;
  font-size: 0.346rem;
  color: #999;
}

.lesson-date {
  margin-top: 0.5rem;
  font-size: 0.346rem;
  color: #EC6D3A;
}

.lesson-rate {
  position: relative;
  margin-top: 0.12rem;
  height: 0.505rem;
}

.lesson-rate-line {
  position: absolute;
  top: 0.212rem;
  height: 0.08rem;
  width: 100%;
  background: #ccc;
  border-radius: 0.053rem;
}

.lesson-rate-line2 {
  position: absolute;
  top: 0.212rem;
  height: 0.08rem;
  background: #ec6d3a;
  border-radius: 0.053rem;
}

.lesson-rate-block-wrapper {
  position: absolute;
  top: 0;
  left: 0.772rem;
  width: 7.656rem;
  margin: 0 auto;
}

.lesson-rate-block {
  position: absolute;
  top: 0;
  margin-left: -0.772rem;
  width: 1.413rem;
  height: 0.373rem;
  padding: 0.066rem 0.066rem;
  background: #ec6d3a;
  border-radius: 0.133rem;
  line-height: 0.373rem;
  text-align: center;
  color: #fff;
  font-size: 0.266rem;
}

.teacher-main {
  overflow-x: scroll;
  overflow-y: hidden;
}

.teacher-items {
  padding: 0.533rem 0.2rem 0.666rem 0.2rem;
}

.teacher-item {
  overflow: hidden;
  position: relative;
  float: left;
  width: 3.813rem;
  margin: 0 0.2rem;
  height: 2.346rem;
  /*border:1px solid #ccc;*/
  border-radius: 0.106rem;
  background: #999;
}

.teacher-item-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.teacher-item-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: blur(10px);
  background: center center no-repeat;
  background-size: 100%;
}

.teacher-item-pic {
  background: #d8dbe4;
  float: left;
  height: 1.44rem;
  width: 1.44rem;
  margin: 0.453rem 0 0 0.12rem;
  border-radius: 0.133rem;
  /*border-radius: 0.106rem;
      border:1px solid #fff;*/
}

.teacher-item-content {
  float: left;
  margin-left: 0.12rem;
  color: #fff;
  max-width: 2rem;
}

.teacher-name {
  margin-top: 0.44rem;
  width: 2rem;
  font-size: 0.453rem;
}

.teacher-line1 {
  margin-top: 0.16rem;
  font-size: 0.32rem;
}

.teacher-line2 {
  margin-top: 0.066rem;
  font-size: 0.32rem;
}

/*.collection{*/
/*padding-bottom: 0.666rem;*/
/*}*/
/*.collection-item{*/
/*margin:0.4rem 0.4rem 0 0.4rem;*/
/*}*/
/*.collection-left{*/
/*overflow:hidden;*/
/*position: relative;*/
/*float:left;*/
/*width:3.733rem;*/
/*height:2.133rem;*/
/*border-radius: 0.106rem;*/
/*}*/
/*.collection-pic{*/
/*width:3.733rem;*/
/*height:2.133rem;*/
/*}*/
/*.collection-left-text{*/
/*position: absolute;*/
/*right:0;*/
/*top:0;*/
/*width:1.2rem;*/
/*height:0.56rem;*/
/*background: rgba(0,0,0,0.4);*/
/*color:#fff;*/
/*text-align: center;*/
/*line-height: 0.56rem;*/
/*border-radius: 0.106rem;*/
/*}*/
/*.collection-content{*/
/*float:right;*/
/*width:5.253rem;*/
/*padding-top:0.133rem;*/
/*}*/
/*.collection-title{*/
/*font-size: 0.453rem;*/
/*color:#333;*/
/*}*/
/*.collection-text{*/
/*margin-top:0.213rem;*/
/*font-size:0.346rem;*/
/*color:#999;*/
/*}*/
/*.collection-info{*/
/*margin-top:0.56rem;*/
/*color:#999;*/
/*font-size: 0.32rem;*/
/*}*/
/*.collection-num{*/
/*float:left;*/
/*}*/
/*.collection-hot{*/
/*float:right;*/
/*}*/
.all-lesson {
  height: 1.52rem;
  line-height: 1.52rem;
  text-align: center;
  color: #EC6D3A;
  font-size: 0.373rem;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue